<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-06-10 14:00:10
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-09 16:58:17
 * @Description: file content
 -->

<template>
  <div class="t3" v-if="pageInfo">
    <UserCard3 v-if="!isShowEditContent"></UserCard3>
    <div v-if="!isShowEditContent" class="title">{{pageInfo.BrowserTabTitle}}</div>
    <div v-if="!isShowEditContent" class="date">{{pageInfo.Articledate}}</div>
    <div
      v-if="!isShowEditContent"
      class="imagetext_content rich_media_content"
      v-html="pageInfo.Imagetext"
    ></div>
    <FoundAuthor></FoundAuthor>
    <FoundDisclaimer></FoundDisclaimer>
    <UserCard4 v-if="isShowGuide&&!isShowEditContent"></UserCard4>
    <EditTitle
      ref="myEditTitle"
      v-if="isShowGuide&&isShowEditContent"
      :initTxt="pageInfo.BrowserTabTitle"
    ></EditTitle>
    <EditContent
      ref="myEdit"
      v-if="isShowGuide&&isShowEditContent"
      :width="'100%'"
      :height="editHeight"
      :content="pageInfo.Imagetext"
    ></EditContent>
    <div v-if="isShowGuide&&isCanEdit" @click="clickCanEdit" class="btn_float">
      <img src="https://assets.rurushishi.com/yq-rs-make/t3/icon_edit.png" alt />
      <span>{{canEditTxt}}</span>
    </div>
    <BubbleShare
      v-if="isShowGuide&&!isShowEditContent&&isShowBubbleShare"
      v-on:close="isShowBubbleShare=false"
    ></BubbleShare>
  </div>
</template>

<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
const UserCard3 = () => import("@/components/usercard3");
const UserCard4 = () => import("@/components/usercard4");
const EditTitle = () => import("@/components/edit_title");
const EditContent = () => import("@/components/edit_content");
const FoundAuthor = () => import("@/components/found_author");
const FoundDisclaimer = () => import("@/components/found_disclaimer");
const BubbleShare = () => import("@/components/bubble_share");

export default {
  components: {
    UserCard3,
    UserCard4,
    EditTitle,
    EditContent,
    FoundDisclaimer,
    FoundAuthor,
    BubbleShare
  },
  props: {},
  data() {
    return {
      isShowEditContent: false,
      isCanEdit: false,
      canEditTxt: "编辑",
      editHeight: "500px",
      isShowBubbleShare: false
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ])
  },
  methods: {
    ...mapMutations({
      SET_PAGEINFO: "SET_PAGEINFO"
    }),
    clickCanEdit() {
      const that = this;
      if (that.canEditTxt == "编辑") {
        //隐藏其他元素只展示编辑框
        that.isShowEditContent = true;
        that.canEditTxt = "保存";
      } else if (that.canEditTxt == "保存") {
        let newTitle = that.$refs.myEditTitle.getContent();
        let newContent = that.$refs.myEdit.getContent();
        if (!newTitle) {
          util.showToast("标题不能为空！");
          return;
        } else if (!newContent) {
          util.showToast("内容不能为空！");
          return;
        }
        comreq.updatePageInfo(that, newContent, newTitle).then(res => {
          if (res.obj) {
            let newPageInfo = that.pageInfo;
            newPageInfo.BrowserTabTitle = newTitle;
            newPageInfo.Imagetext = newContent;
            that.SET_PAGEINFO(newPageInfo);
            that.isShowEditContent = false;
            that.canEditTxt = "编辑";
          }
        });
      }
    },
    scrollEvent() {
      // console.log(
      //   `document.body.scrollTop:${document.body.scrollTop} this.$clientHeight:${this.$clientHeight} document.body.scrollHeight:${document.body.scrollHeight}`
      // );
      if (document.body.scrollHeight - this.$clientHeight > 100) {
        let tmpNum =
          document.body.scrollHeight -
          this.$clientHeight -
          document.body.scrollTop;
        if (tmpNum < 100) {
          this.isShowBubbleShare = true;
        } else {
          this.isShowBubbleShare = false;
        }
      }
    }
  },
  created() {
    let that = this;
    util.checkMapStateCallback(that, ["hdkUserInfo", "pageInfo"]).then(() => {
      if (
        that.pageInfo.Actuuid &&
        that.hdkUserInfo.User &&
        that.hdkUserInfo.User.Id &&
        that.pageInfo.Actuuid == that.hdkUserInfo.User.Id
      ) {
        that.isCanEdit = true;
      }
    });
    window.addEventListener("scroll", that.scrollEvent, true);
  },
  mounted() {
    this.editHeight = this.$clientHeight - this.$tabbarHeight;
  }
};
</script>
<style lang="css" scoped>
/* 标题 */
.title {
  margin: 10px;
  font-size: 20px;
  font-weight: 600;
  line-height: 25px;
  font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
}
/* 日期 */
.date {
  margin: 10px;
  font-size: 14px;
}

/* 编辑按钮 */
.btn_float {
  position: fixed;
  top: 50%;
  right: 10px;
  height: 30px;
  width: 80px;
  line-height: 30px;
  text-align: center;
  background-color: #ff7e7e;
  color: #ffffff;
  border-radius: 20px;
}
.btn_float img {
  width: 18px;
  height: 18px;
  padding-right: 5px;
}
.btn_float span {
  font-size: 12px;
}
</style>